import { css } from '@microsoft/fast-element';
import { zeroTextFieldStyles } from '../text-field';
export const zeroNumberFieldStyles = (context, definition) => css `
  :host .root {
    --focus-stroke-outer: transparent;
  }
  ${zeroTextFieldStyles(context, definition)}
`;
